/**
 * 设备检测工具类
 * 用于判断当前设备类型和屏幕特性
 */

class DeviceDetector {
  constructor() {
    this.userAgent = navigator.userAgent.toLowerCase()
    this.platform = navigator.platform.toLowerCase()
  }

  /**
   * 检测是否为移动设备
   */
  isMobile() {
    return (
      /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(this.userAgent) ||
      /mobile/i.test(this.userAgent) ||
      (window.innerWidth <= 768 && !this.isIOS())
    )
  }

  /**
   * 检测是否为平板设备
   */
  isTablet() {
    return (
      /ipad/i.test(this.userAgent) ||
      (/android/i.test(this.userAgent) && !/mobile/i.test(this.userAgent)) ||
      (window.innerWidth >= 768 && window.innerWidth <= 1024 && !this.isMobile())
    )
  }

  /**
   * 检测是否为桌面设备
   */
  isDesktop() {
    return !this.isMobile() && !this.isTablet()
  }

  /**
   * 获取设备类型
   */
  getDeviceType() {
    if (this.isMobile()) return 'mobile'
    if (this.isTablet()) return 'tablet'
    return 'desktop'
  }

  /**
   * 检测触摸支持
   */
  isTouchSupported() {
    return (
      'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    )
  }

  /**
   * 获取屏幕信息
   */
  getScreenInfo() {
    return {
      width: window.screen.width,
      height: window.screen.height,
      availWidth: window.screen.availWidth,
      availHeight: window.screen.availHeight,
      orientation: window.orientation || 0,
      pixelRatio: window.devicePixelRatio || 1
    }
  }

  /**
   * 检测是否为iOS设备
   */
  isIOS() {
    return /iphone|ipad|ipod/i.test(this.userAgent)
  }

  /**
   * 检测是否为Android设备
   */
  isAndroid() {
    return /android/i.test(this.userAgent)
  }

  /**
   * 检测是否为微信浏览器
   */
  isWeChat() {
    return /micromessenger/i.test(this.userAgent)
  }

  /**
   * 检测是否为特定浏览器
   */
  isBrowser(browserName) {
    const browsers = {
      chrome: /chrome/i,
      firefox: /firefox/i,
      safari: /safari/i,
      edge: /edge/i,
      ie: /msie|trident/i
    }
    
    const regex = browsers[browserName.toLowerCase()]
    return regex ? regex.test(this.userAgent) : false
  }
}

// 创建全局实例
const deviceDetector = new DeviceDetector()

// Vue插件形式导出
export default {
  install(app) {
    app.config.globalProperties.$device = deviceDetector
    app.provide('$device', deviceDetector)
  }
}

// 直接导出实例
export { deviceDetector }